const FOOTER_SERVICES = [
  'HVAC', 'Plumbing', 'Electrical', 'Porches & Decks',
  'Roofing & Siding', 'Painting', 'Remodeling', 'Commercial Buildouts',
];

const FOOTER_LINKS = [
  { label: 'About Us', href: '#about' },
  { label: 'Why Choose Us', href: '#why' },
  { label: 'Areas Served', href: '#areas' },
  { label: 'Contact Us', href: '#contact' },
];

export default function FooterSection() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-blue-950">
      {/* Upper Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 flex items-center justify-center">
                <img
                  src="https://static.readdy.ai/image/6645531746f64686987a03e27da8ae74/16f64b1b2195676dda194d0cc4a4f313.jpeg"
                  alt="Butler Frelix Construction LLC"
                  className="w-12 h-12 object-contain rounded-md"
                />
              </div>
              <div>
                <div className="text-white font-black text-sm" style={{ fontFamily: "'Oswald', sans-serif" }}>BUTLER FRELIX</div>
                <div className="text-red-400 text-xs tracking-widest" style={{ fontFamily: "'Inter', sans-serif" }}>CONSTRUCTION LLC</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-5 italic" style={{ fontFamily: "'Inter', sans-serif" }}>
              Where Every Build Becomes a Legacy
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mb-5" style={{ fontFamily: "'Inter', sans-serif" }}>
              Licensed &amp; insured general contractor serving Chicago and surrounding suburbs since 2013.
            </p>
            <div className="flex items-center gap-3">
              {['ri-facebook-fill', 'ri-instagram-line', 'ri-linkedin-fill'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-8 h-8 flex items-center justify-center bg-white/5 hover:bg-red-700 rounded-lg transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-gray-400 hover:text-white text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-black text-sm uppercase tracking-wider mb-5" style={{ fontFamily: "'Oswald', sans-serif" }}>
              <a id="footer-services-anchor">Our Services</a>
            </h4>
            <div className="flex flex-col gap-2.5">
              {FOOTER_SERVICES.map((service) => (
                <button
                  key={service}
                  onClick={() => scrollTo('#services')}
                  className="text-gray-400 hover:text-red-400 text-sm text-left transition-colors cursor-pointer whitespace-nowrap"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {service}
                </button>
              ))}
            </div>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-black text-sm uppercase tracking-wider mb-5" style={{ fontFamily: "'Oswald', sans-serif" }}>
              <a id="footer-company-anchor">Company</a>
            </h4>
            <div className="flex flex-col gap-2.5">
              {FOOTER_LINKS.map((link) => (
                <button
                  key={link.label}
                  onClick={() => scrollTo(link.href)}
                  className="text-gray-400 hover:text-red-400 text-sm text-left transition-colors cursor-pointer whitespace-nowrap"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-black text-sm uppercase tracking-wider mb-5" style={{ fontFamily: "'Oswald', sans-serif" }}>
              <a id="footer-contact-anchor">Get In Touch</a>
            </h4>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-red-500 text-sm" />
                </div>
                <span className="text-gray-400 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
                  Chicago, IL &amp; Greater Chicagoland Area
                </span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-red-500 text-sm" />
                </div>
                <a href="tel:+13123990278" className="text-gray-400 hover:text-red-400 text-sm transition-colors cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>
                  312-399-0278
                </a>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-red-500 text-sm" />
                </div>
                <a href="mailto:build@bfclegacy.com" className="text-gray-400 hover:text-red-400 text-sm transition-colors cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>
                  build@bfclegacy.com
                </a>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-red-500 text-sm" />
                </div>
                <span className="text-gray-400 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
                  Mon–Sat: 7:00 AM – 7:00 PM
                </span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-red-500 text-sm" />
                </div>
                <span className="text-gray-400 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
                  Licensed &amp; Insured in Illinois
                </span>
              </div>
            </div>
            <button
              onClick={() => scrollTo('#contact')}
              className="mt-6 w-full bg-red-700 hover:bg-red-800 text-white font-semibold text-sm py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Request a Free Quote
            </button>
          </div>
        </div>
      </div>

      {/* Lower Footer Bar */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-500 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>
            &copy; 2026 Butler Frelix Construction LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" rel="nofollow" className="text-gray-500 hover:text-gray-300 text-xs transition-colors whitespace-nowrap" style={{ fontFamily: "'Inter', sans-serif" }}>
              Privacy Policy
            </a>
            <span className="text-gray-700 text-xs">|</span>
            <a href="#" rel="nofollow" className="text-gray-500 hover:text-gray-300 text-xs transition-colors whitespace-nowrap" style={{ fontFamily: "'Inter', sans-serif" }}>
              Terms of Service
            </a>
          </div>
          <div className="flex items-center gap-1.5 text-gray-500 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-map-pin-fill text-red-500 text-xs" />
            </div>
            Made in Chicago, IL
          </div>
        </div>
      </div>
    </footer>
  );
}
